import { render, staticRenderFns } from "./checkCerificate.vue?vue&type=template&id=c71c3bd0&scoped=true&"
import script from "./checkCerificate.vue?vue&type=script&lang=js&"
export * from "./checkCerificate.vue?vue&type=script&lang=js&"
import style0 from "./checkCerificate.vue?vue&type=style&index=0&id=c71c3bd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71c3bd0",
  null
  
)

export default component.exports